<div style="padding: 0 1rem 3rem 1rem;" fxLayout="column">

    <div [style.marginBottom]="'1em'" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
            <span style="padding-top: .5em;" class="folio-header-style">{{MY_CONSTANT.LABEL_TEAMS_HEADER_TITLE}}</span>
        </div>
        <button mat-raised-button color="accent" (click)="addNewPermitClick()" joyrideStep="teamCreateBtnStep"
            [title]="'Click here to create a new team.'">
            Add Team
        </button>
    </div>

    <div *ngIf="!showTable">{{showTableDataLabel}}</div>
    <!-- Table with filter, sort and pagintaion START -->
    <div joyrideStep="teamsListStep" [title]="'Here you can view the list of teams.'">
        <!-- Table start -->
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" #table>
            <!-- Team ID Column -->
            <ng-container matColumnDef="TEAM_ID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="teamId">Team ID
                </th>
                <td mat-cell *matCellDef="let element">
                    <span style="vertical-align: bottom; text-transform: capitalize;"> {{element.TEAM_ID}}</span>
                </td>
            </ng-container>

            <!-- Team Name Column -->
            <ng-container matColumnDef="TEAM_NAME">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="teamName">
                    {{MY_CONSTANT.LABEL_TEAMS_PLACEHOLDER_TEAM_NAME}}
                </th>
                <td mat-cell *matCellDef="let element">
                    <!-- <mat-icon>people_outline</mat-icon> -->
                    <a style="vertical-align: bottom; text-transform: capitalize; cursor: pointer; text-decoration: underline;"
                        (click)="navigateToFormWithID(element)"> {{(element.TEAM_NAME ? element.TEAM_NAME :
                        '') | slice:0:charLimit}}</a>
                </td>
            </ng-container>

            <!-- Team Lead Column -->
            <ng-container matColumnDef="TEAM_LEAD">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="teamLead">
                    {{MY_CONSTANT.LABEL_TEAMS_PLACEHOLDER_ADMINISTRATOR}}</th>
                <td mat-cell *matCellDef="let element">
                    {{(element.TEAM_LEAD ? element.TEAM_LEAD : '-') | slice:0:charLimit}}
                </td>
            </ng-container>

            <!-- View ICON -->
            <ng-container matColumnDef="view">
                <th mat-header-cell *matHeaderCellDef id="viewIcon"></th>
                <td mat-cell *matCellDef="let element" style="width: 1rem;">
                    <div>
                        <button id='viewIcon' mat-icon-button matTooltip="{{MY_CONSTANT.LABEL_TOOLTIP_EDIT}}"
                            class="background-hover-highlight" (click)="navigateToFormWithID(element)">
                            <mat-icon color="primary">edit</mat-icon>
                        </button>
                    </div>
                </td>
            </ng-container>
            <!-- View ICON END-->

            <!-- Delete ICON -->
            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef id="deleteIcon">
                </th>
                <td mat-cell *matCellDef="let element" style="width: 1rem;">
                    <div>
                        <button id='viewIcon' mat-icon-button matTooltip="{{MY_CONSTANT.LABEL_TOOLTIP_DELETE}}"
                            class="background-hover-highlight" (click)="deleteRecord(element)">
                            <mat-icon color="primary">delete</mat-icon>
                        </button>
                    </div>
                </td>
            </ng-container>
            <!-- Delete ICON END-->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="visibility">
            </tr>
        </table>

        <!-- paginator -->
        <mat-paginator class="primary-inline-color mat-elevation-z8" [pageSizeOptions]="[10, 25, 50, 75]">
        </mat-paginator>
    </div>
    <!-- Table with filter, sort and pagintaion END -->
    <span *ngIf="!teams.length" style="text-align: center; margin-top: 1em;">{{MY_CONSTANT.LABEL_NO_DATA}}</span>

</div>